import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import L from 'leaflet';
import { useMap } from 'react-leaflet'; // import MarkerClusterGroup from 'react-leaflet-markercluster'

import cx from 'classnames';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import { setOpenDialog, setDialogContent } from '../../redux/traffic-dashboard';
var t = i18n.getFixedT(null, 'traffic-live');
var TrafficEventMarkers = /*#__PURE__*/React.memo(function () {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      trafficEventMarkers = _useSelector.trafficDashboard.trafficEventMarkers;

  var dispatch = useDispatch();
  var markersLayerGroup = useRef();
  var map = useMap();

  var openDialog = function openDialog(markerData) {
    dispatch(setOpenDialog(true));
    dispatch(setDialogContent(markerData));
  };

  var clearAllMarkers = function clearAllMarkers() {
    if (!markersLayerGroup.current) return;
    markersLayerGroup.current.clearLayers();
    markersLayerGroup.current = null;
  };

  useEffect(function () {
    clearAllMarkers();
    markersLayerGroup.current = new L.layerGroup();
    var markerClusterGroup = new L.MarkerClusterGroup({
      showCoverageOnHover: false,
      spiderfyDistanceMultiplier: 2,
      maxClusterRadius: function maxClusterRadius() {
        return 40;
      },
      iconCreateFunction: function iconCreateFunction(cluster) {
        return L.divIcon({
          html: "<span>".concat(cluster.getChildCount(), "</span>"),
          className: cx('marker-cluster', 'abcde'),
          iconSize: L.point(30, 30, true)
        });
      }
    });

    var newMarkers = _.map(trafficEventMarkers, function (el) {
      var markerIcon = L.divIcon({
        className: 'location-pin',
        html: '<div class="circle"></div><div class="pin"></div>',
        iconSize: [26, 26],
        iconAnchor: [18, 26]
      });
      var marker = L.marker({
        lon: el.longitude,
        lat: el.latitude
      }, {
        icon: markerIcon
      });
      marker.on('click', function () {
        return openDialog(el);
      });
      var tooltipIcon = "<div class='marker-tooltip'>\n                <p style=\"margin: unset\">".concat(el.description, "</p>\n                <p style=\"margin: unset\">").concat(el.beginTime, "</p>\n            </div>");
      var tooltipOptions = {
        className: 'tooltip',
        direction: 'bottom',
        offset: [1, 5],
        opacity: 1 // permanent: true

      };
      marker.bindTooltip(tooltipIcon, tooltipOptions);
      return marker;
    });

    markerClusterGroup.addLayers(newMarkers);
    markerClusterGroup.addTo(markersLayerGroup.current);
    markersLayerGroup.current.addTo(map);
    return function () {
      clearAllMarkers();
    };
  }, [JSON.stringify(trafficEventMarkers)]);
  return null;
});
export default TrafficEventMarkers;